import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, isRef as _isRef, createElementBlock as _createElementBlock } from "vue"

import { ref, Ref, reactive, onBeforeMount } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import {useRouter} from 'vue-router'
import tbMix from '@/global_mixin/tableMixin'
import dayjs from 'dayjs'
import { formatNumber, getNumber, formatTime } from '@/utils/index'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

let {
  'POST/order_profit/order_category_report': fetchList,
  // 获取订单列表
  'POST/order_cost/query_order': orderListApi,
  // 订单导出
  'POST/order_cost/export_order': exportOrderApi,
} = Api

const { fetchData , MI_height, MI_params } = new tbMix(fetchList) 
const { fetchData: fetchOrder, MI_tableData: orderData, MI_params: orderParams,
  MI_identify: orderLoading, page, size, MI_pageChange, MI_sizeChange, MI_total 
} = new tbMix(orderListApi) 
const router = useRouter()

const searchConfig = ref([
  {
    type: "TIME",
    label: "订单交付时间",
    value: [],
    upKey: 'deliverTime',
    upProps: { startKey: 'deliverTimeFrom', endKey: 'deliverTimeTo', },
    props: { type: 'daterange', 'value-format': 'YYYY-MM-DD', clearable: true }
  },
  {
    type: "TIME",
    label: "订单开始时间",
    value: [],
    upKey: 'time',
    upProps: { startKey: 'startTimeFrom', endKey: 'startTimeTo', },
    props: { type: 'monthrange', 'value-format': 'YYYY-MM-DD', clearable: true }
  },
  {
    type: "TIME",
    label: "订单关闭时间",
    value: [dayjs().subtract(1, 'month').startOf('month').format('YYYY-MM-DD'), dayjs().subtract(1, 'month').endOf('month').format('YYYY-MM-DD')],
    upKey: 'closeTime',
    upProps: { startKey: 'closeTimeFrom', endKey: 'closeTimeTo', },
    props: { type: 'monthrange', 'value-format': 'YYYY-MM-DD', clearable: true }
  },
])

const isTbLoading = ref(false)

let resultTableData: any = ref([])
const searchHandle =  (params: any) => {
  isTbLoading.value = true
  fetchData(params).then((result) => {

    let {
      orderTotalAmount, orderTotalRatio, costExternalTotalAmount, costInnerTotalAmount, costTotalRatio,
      orderCategoryIncome, orderCategoryCost, regionIncome, regionCost
    } = result
  
    let orderArr = orderCategoryIncome.reduce((arr: any[], item: any, index: number) => {
      arr.push({
        ...item,
        externalAmount: orderCategoryCost[index].externalAmount,
        innerAmount: orderCategoryCost[index].innerAmount,
        costRatio: orderCategoryCost[index].ratio,
      })
      return arr
    }, [{name: '订单类别', type: 'splitLine'}])
  
    let costArr = regionIncome.reduce((arr: any[], item: any, index: number) => {
      arr.push({
        ...item,
        externalAmount: regionCost[index].externalAmount,
        innerAmount: regionCost[index].innerAmount,
        costRatio: regionCost[index].ratio,
      })
      return arr
    }, [{name: '地域', type: 'splitLine'}])
  
    resultTableData.value = [{
      name: '营业收入合计', 
      amount: orderTotalAmount, 
      ratio: orderTotalRatio, 
      costExternalTotalAmount: costExternalTotalAmount,
      costInnerTotalAmount: costInnerTotalAmount,
      costRatio: costTotalRatio,}].concat(orderArr).concat(costArr)

  }).finally(() => {
    isTbLoading.value = false
  })
  
}

// 跳转
const isShowOrder = ref<boolean>(false)
const switchPageHandle = (row: any, column: any) => {
  if(['未指定', '差异'].includes(row.name) || row.type === 'splitLine'){
    return
  }
  
  if(column.property === 'amount'){
    // 展示订单弹框
    isShowOrder.value = true
    fetchOrder({
      deliverTimeFrom: MI_params.deliverTimeFrom,
      deliverTimeTo: MI_params.deliverTimeTo,
      startTimeFrom: MI_params.startTimeFrom,
      startTimeTo: MI_params.startTimeTo,
      closeTimeFrom: MI_params.closeTimeFrom,
      closeTimeTo: MI_params.closeTimeTo,
      categoryId: row.categoryId,
    })
  }
  if(column.property === 'costAmount'){
    router.push({ 
      path: '/rt', 
      query: {
        categoryId: row.categoryId,
        resourceCurrency: ["CNY", "USD"],
        deliverTimeFrom: MI_params.deliverTimeFrom,
        deliverTimeTo: MI_params.deliverTimeTo,
        isNoCalculated: 'false',
        existTestCost: 'false',
      }
    })
  }
}

// --------------
const tableRowClassName = ({row, rowIndex,}: any) => {
  if (row.type === 'splitLine') {
    return 'split-line'
  }
  return ''
}

const formatRatioHandle = (ratio: number) => {
  if(!ratio){
    return '-'
  }
  return (ratio * 100).toFixed(2) + '%'
}


return (_ctx: any,_cache: any) => {
  const _component_FlexibleForm = _resolveComponent("FlexibleForm")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_eptBtn = _resolveComponent("eptBtn")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_collapse, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, { title: "订单类别报表-搜索" }, {
          default: _withCtx(() => [
            _createVNode(_component_FlexibleForm, _mergeProps({ ref: "searchForm" }, {
          initSearch: true,
          title: true,
          searchConfig: searchConfig.value,
        }, { onSearchFn: searchHandle }), null, 16)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      style: {"width":"55%"},
      ref: "tb",
      border: "",
      class: "mt-10",
      onRowDblclick: switchPageHandle,
      "row-class-name": tableRowClassName,
      data: _unref(resultTableData),
      "max-height": _unref(MI_height) - 30 + "px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "",
          prop: "name",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          align: "right",
          label: "收入(双击穿透)",
          prop: "amount",
          "show-overflow-tooltip": "",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          align: "right",
          label: "占比",
          prop: "ratio",
          "show-overflow-tooltip": "",
          formatter: (row) => formatRatioHandle(row.ratio)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          align: "right",
          label: "内部译员成本",
          prop: "innerAmount",
          "show-overflow-tooltip": "",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          align: "right",
          label: "外部译员成本",
          prop: "externalAmount",
          "show-overflow-tooltip": "",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          align: "right",
          label: "占比",
          prop: "costRatio",
          "show-overflow-tooltip": "",
          formatter: (row) => formatRatioHandle(row.costRatio)
        }, null, 8, ["formatter"])
      ]),
      _: 1
    }, 8, ["data", "max-height"])), [
      [_directive_loading, isTbLoading.value]
    ]),
    _createVNode(_component_el_dialog, {
      title: "订单列表",
      modelValue: isShowOrder.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((isShowOrder).value = $event)),
      draggable: "",
      width: "80%"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tooltip, {
          effect: "dark",
          content: "请先搜索后再导出",
          placement: "top-end"
        }, {
          default: _withCtx(() => [
            _withDirectives(_createVNode(_component_eptBtn, {
              exportFn: _unref(exportOrderApi),
              exportText: '导出',
              exportParam: _unref(orderParams)
            }, null, 8, ["exportFn", "exportParam"]), [
              [_directive_permission, 'Export']
            ])
          ]),
          _: 1
        }),
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          border: "",
          data: _unref(orderData),
          "max-height": "700px",
          class: "mt-10"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "订单编号",
              prop: "no",
              "show-overflow-tooltip": "",
              fixed: ""
            }),
            _createVNode(_component_el_table_column, {
              label: "服务类别",
              prop: "category",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "原始金额",
              prop: "amount",
              align: "right",
              "show-overflow-tooltip": ""
            }, {
              default: _withCtx(({row}) => [
                _createTextVNode(_toDisplayString(_unref(getNumber)(parseFloat(row.amount))), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "原始币别",
              prop: "standardMoney",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "服务金额(USD)",
              prop: "baseCurrencyMoney",
              align: "right"
            }, {
              default: _withCtx(({row}) => [
                _createTextVNode(_toDisplayString(_unref(getNumber)(parseFloat(row.baseCurrencyMoney))), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "客户经理",
              prop: "owner",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "开始日期",
              prop: "startTime",
              formatter: _unref(formatTime),
              "show-overflow-tooltip": ""
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              label: "交付日期",
              prop: "deliverTime",
              formatter: _unref(formatTime),
              "show-overflow-tooltip": ""
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              label: "订单状态",
              prop: "status",
              "show-overflow-tooltip": ""
            })
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, _unref(orderLoading)]
        ]),
        _createVNode(_component_el_pagination, {
          background: "",
          small: "",
          total: _unref(MI_total),
          currentPage: _unref(page),
          "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
          "page-size": _unref(size),
          "onUpdate:page-size": _cache[1] || (_cache[1] = ($event: any) => (_isRef(size) ? (size).value = $event : null)),
          class: "mt-10",
          style: {"float":"none"},
          "page-sizes": [10, 30, 50, 100, 300, 500],
          layout: "sizes, prev, pager, next, total, jumper",
          onCurrentChange: _unref(MI_pageChange),
          onSizeChange: _unref(MI_sizeChange)
        }, null, 8, ["total", "currentPage", "page-size", "onCurrentChange", "onSizeChange"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})